export default "__VITE_ASSET__gTjKqIVCw7uI3M8zY2UvBA__"